const SelloTiempoBitacora = ({...props}) => {
	const selloTiempo = props.data;
	return (
		<div className="d-flex align-items-center">
			<span className="text-nowrap">{selloTiempo}</span>
		</div>
	)
}
export default SelloTiempoBitacora;
